import { VisitorState, VisitState } from './features/visits/api/types/visits';

export const statusVariants = [
  {
    color: 'rgba(6, 70, 153, 1)',
    label: 'Created',
    value: VisitState.CREATED,
  },
  {
    color: '#a53531',
    label: 'Cancelled',
    value: VisitState.CANCELLED,
  },
  {
    color: '#1b774d',
    label: 'Started',
    value: VisitState.STARTED,
  },
  {
    color: '#506176',
    label: 'Finished',
    value: VisitState.FINISHED,
  },
  {
    color: '#a53531',
    label: 'Rejected',
    value: VisitState.REJECTED,
  },
];

export const statusVisitorVariants = [
  {
    color: 'rgba(6, 70, 153, 1)',
    label: 'Invited',
    value: VisitorState.INVITED,
  },
  {
    color: '#a53531',
    label: 'Cancelled',
    value: VisitorState.CANCELLED,
  },
  {
    color: '#1b774d',
    label: 'Arrived',
    value: VisitorState.ARRIVED,
  },
  {
    color: '#506176',
    label: 'Left',
    value: VisitorState.LEFT,
  },
  {
    color: '#ffa500',
    label: 'Awaiting Approval',
    value: VisitorState.AWAITING_APPROVAL,
  },
];

export const booleanVariants = [
  {
    color: '#a53531',
    label: 'Yes',
    value: true,
  },
  {
    color: '#1b774d',
    label: 'No',
    value: false,
  },
];
